import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const InvisibleIcon = ({ color = '#B5BCBD', size = 14, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 13 11"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M6.434 2.993c1.419 0 2.574 1.125 2.574 2.507 0 .09 0 .179-.013.281l1.865 1.816A11.568 11.568 0 0 0 12.869 5.5c-1.76-2.353-4.005-3.76-6.435-3.76-.485 0-.958.05-1.418.166l1.13 1.1c.105-.013.197-.013.288-.013zM.827.934l1.97 1.918C1.787 3.492.84 4.387 0 5.5c1.76 2.353 4.005 3.76 6.434 3.76.84 0 1.668-.179 2.443-.486l2.246 2.188.906-.883L1.747.04l-.92.895zM3.86 5.5c0-.46.132-.895.355-1.266l.971.946a1.262 1.262 0 0 0-.052.32c0 .69.578 1.254 1.287 1.254.118 0 .223-.026.328-.051l.972.946c-.38.218-.827.346-1.3.346-1.405.012-2.56-1.114-2.56-2.495z" />
    </g>
  </svg>
);

InvisibleIcon.propTypes = propTypes;

export default InvisibleIcon;
